import { reactive } from 'vue'

interface Settings {
  settings: any,
}

interface SettingsLogo {
  logo: string,
}

type WindowType = Window & typeof globalThis & {
  gornSettings?: any
}

const settings = reactive((<any>window).gornSettings)
export const useSettingsLogo = (): SettingsLogo => {
  return {
    logo: (window as WindowType).gornSettings?.Logo
  }
}

export const useSettings = (): Settings => {
  return {
    settings,
  }
}
